import BaseModel from '../core/BaseModel'

export default class TypeFailureCauseModel extends BaseModel {
    constructor() {
        super({
                name: "type_failure_cause",
                tableName: 'core_type_failure_cause'
            },
            {
                id: {
                    name: 'id',
                    type: "String",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                fied_detail: {
                    refs: ' code name',
                    display: false
                },
            },)
    }
}